import {
  Actions,
  AppArea,
  CurrentUserDocument,
  Subjects,
  UserAssignProgramDocument,
} from '../../graphql/generated/graphql';
import { useCan } from 'src/utils/can';
import { usePrograms } from 'src/hooks/query/use-programs';
import {
  BottomNavigation,
  Button,
  Card,
  PageModal,
  useNotifications,
} from '@otp/ui';
import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { Arrow } from '@otp/icons';
import { useTranslation } from 'react-i18next';
import { TermsAndConditionsContent } from 'src/components/onboarding/terms-and-conditions-content';
import { useAuthContext } from 'src/context/auth.context';
import { SUPPORT_EMAIL } from 'src/constants/config';
import { Routes } from 'src/components/common/router/constants';
import { useNavigate } from 'react-router-dom';

export const Onboarding = () => {
  const notifications = useNotifications();
  const navigate = useNavigate();
  const { loadUser } = useAuthContext();
  const { t } = useTranslation();
  const { can } = useCan();
  const { programs, loading: isProgramsLoading } = usePrograms();
  const [showTS, setShowTS] = useState(false);

  const [assignUserProgram, { loading: isLoading }] = useMutation(
    UserAssignProgramDocument,
    {
      refetchQueries: [CurrentUserDocument],
    },
  );

  const availableUserProgram = programs.find((program) => {
    return can({
      action: Actions.Assign,
      subject: Subjects.Program,
      appArea: AppArea.Lms,
      data: { id: program.id },
    });
  });

  const onCloseTS = () => setShowTS(false);

  const joinProgram = async () => {
    if (!availableUserProgram) {
      return;
    }

    await assignUserProgram({
      variables: {
        data: {
          programId: availableUserProgram.id,
        },
      },
    });
    await loadUser();

    notifications.show(t('onboarding.program-assigned-successfully'));

    navigate(`${Routes.editProfile.path}?postRedirect=lmsCurriculums`);
  };

  if (isProgramsLoading) {
    return null;
  }

  if (!availableUserProgram) {
    return (
      <div className="flex items-center justify-center mt-40">
        <div>
          <p>{t('onboarding.no-program-assigned')}</p>
          <p className="text-center">
            Please{' '}
            <u>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="inline">
                contact
              </a>
            </u>{' '}
            administrator
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-center mt-20">
        <Card onClick={() => setShowTS(true)} isLink padding={4}>
          <div className="pb-16 cursor-pointer">
            Join the <b>{availableUserProgram.name}</b> program
          </div>
        </Card>
      </div>
      {showTS && (
        <PageModal
          open
          onClose={onCloseTS}
          title="OTP Mobile App - Terms of Use"
        >
          <TermsAndConditionsContent />
          <BottomNavigation>
            <Button variant="outlined" className="grow" onClick={onCloseTS}>
              <Arrow /> &nbsp; {t('common.cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              className="grow"
              disabled={isLoading}
              onClick={joinProgram}
            >
              {t('common.agree')}
            </Button>
          </BottomNavigation>
        </PageModal>
      )}
    </div>
  );
};
